import TabHelper from './tab-helper';

const contentMatcher = (node, delta) => {
  const newOps = [];
  delta.ops.forEach((op) => {
    if (!op.insert) {
      newOps.push(op);
    } else {
      op.insert = TabHelper.replaceTabs(op.insert);

      if (op.insert !== '') {
        newOps.push(op);
      }
    }
  });
  delta.ops = newOps;
  return delta;
};

export default class QuillHelper {
  static addDefaultBehaviour(options) {
    options.modules = options.modules || {};

    // Clipboard
    options.modules.clipboard = options.modules.clipboard || {};
    options.modules.clipboard.matchVisual = false;
    options.modules.clipboard.matchers = options.modules.clipboard.matchers || [];
    options.modules.clipboard.matchers.push([ Node.ELEMENT_NODE, contentMatcher ]);
    // END Clipboard

    // Keyboard
    options.modules.keyboard = options.modules.keyboard || {};
    options.modules.keyboard.bindings = options.modules.keyboard.bindings || {};
    options.modules.keyboard.bindings.tab = {
      key: 9,
      handler: TabHelper.tabKeyboardHandler,
    };
    // END Keyboard

    return options;
  }
}
